import { axiosRequest } from '@planbord/axios-request';
import { useMutation } from '@tanstack/vue-query';

export const useUpdateTime = () => {
  const baseUrl = '/api';

  return useMutation({
    mutationFn: (value: { Id: number; TimeId: number }) =>
      axiosRequest
        .put(`${baseUrl}/updateTime/${value.Id}`, value.TimeId)
        .then((res) => {
          return res.data;
        }),
  });
};
